<template>
  <CCallout color="primary">
    <h6 class="text-primary">{{ info.title }}</h6>
    <p class="text-break">{{ info.description }}</p>
    <div
      style="cursor: pointer"
      class="preview-img"
      @click="enlargeImg = !enlargeImg"
    >
      <CImage
        v-if="info.img"
        rounded
        thumbnail
        :src="info.img"
        width="200"
        height="200"
        class="mb-4"
      />
      <img
        v-if="info.img"
        class="enlarge"
        src="@/assets/icons/enlarge.svg"
        alt=""
      />
    </div>
    <EnLargeImg :show="enlargeImg" :image="info.img" />
  </CCallout>
</template>

<script>
import EnLargeImg from '@/components/EnLargeImg.vue'
import { ref } from '@vue/reactivity'

export default {
  components: {
    EnLargeImg,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    id: {
      type: Number,
      default: null,
    },
  },
  setup() {
    const enlargeImg = ref(false)
    return {
      enlargeImg,
    }
  },
}
</script>
<style lang="scss" scoped>
.enlarge {
  width: 20px;
  position: absolute;
  right: 5px;
  bottom: 30px;
}
.preview-img {
  width: 200px;
  position: relative;
}
</style>
